import { Injectable } from '@angular/core';
import { createClient, Entry, Space, ContentfulClientApi } from 'contentful';

// change these to include your own settings
const DEFAULT_CONFIG = {
  credentials: {
    space: 'jg0yoqupjod6',
    accessToken: 'b90bfca55ff60ad07d9dc53d9e7882d0042d8842d402a20c26a8a628a25f70bb',
  },

  contentTypeIds: {
    artifact: 'artifact',
    category: 'category',
    brand: 'brand',
    settings: 'settings'
  }
};

@Injectable()
export class ContentfulService {
  cdaClient: ContentfulClientApi;
  config: {
    space: string,
    accessToken: string
  };
  titleHandlers: Function[];

  constructor() {
    try {
      this.config = JSON.parse(localStorage.catalogConfig);
    } catch (e) {
      this.config = DEFAULT_CONFIG.credentials;
    }

    this.titleHandlers = [];
    this._createClient();
    this.getSpace();
  }

  onTitleChange(fn): void {
    this.titleHandlers.push(fn);
  }

  getSpace(): Promise<Space> {
    return this.cdaClient.getSpace()
      .then(space => {
        this.titleHandlers.forEach(handler => handler(space.name));

        return space;
      });
  }

  getReferanslar(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: DEFAULT_CONFIG.contentTypeIds.brand,  order: '-sys.updatedAt'
    }, query))
      .then(res => res.items);
  }

  getCategories(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: DEFAULT_CONFIG.contentTypeIds.category,  order: '-sys.updatedAt'
    }, query))
      .then(res => res.items);
  }

  getAllArtifacts(): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries({
      content_type: DEFAULT_CONFIG.contentTypeIds.artifact, order: '-sys.updatedAt' })
    .then(res => res.items);
  }

  getSettings(): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries({
      content_type: DEFAULT_CONFIG.contentTypeIds.settings })
    .then(res => res.items);
  }

  getArtifactsByCategoryId(categoryId): Promise<Entry<any>[]> {
    (window as any).test = this.cdaClient;

    // test.getEntries({content_type: 'artifact', 'fields.categories.sys.id': '3rePdCEM1Jo2AMu6Ggnf3F'}).then((a)=> { console.log(a);})
    console.log("test.getEntries({content_type: 'artifact', 'fields.categories.sys.id': '3rePdCEM1Jo2AMu6Ggnf3F'}).then((a)=> { console.log(a);})");

    return this.cdaClient.getEntries({
      content_type: DEFAULT_CONFIG.contentTypeIds.artifact, 'fields.categories.sys.id': categoryId, order: '-sys.updatedAt' })
      .then(res => res.items);
  }

  _createClient() {
    this.cdaClient = createClient({
      space: this.config.space,
      accessToken: this.config.accessToken
    });
  }
}
